import classnames from "classnames";
import { Ref } from "react";

import styles from "./FormInputRadio.module.css";

const FormInputRadio: React.FC<FormInputRadioProps> = ({
  options,
  id,
  label,
  error,
  required,
}) => {
  const referenceId = id || options[0].name || "";
  return (
    <fieldset>
      <legend className={styles.legend}>
        {required && <span aria-hidden={true}>*</span>} {label}
      </legend>
      <ul className={styles.options}>
        {options.map(({ label, ...restOptions }, key) => (
          <li key={key} className={styles.option}>
            <label
              className={classnames(styles.label, {
                [styles.labelDisabled]: restOptions.disabled,
              })}
            >
              <input
                className={styles.input}
                type="radio"
                aria-describedby={error && `${referenceId}_error`}
                {...restOptions}
              />
              <svg className={styles.icon} viewBox="0 0 16 16">
                <circle cx="8" cy="8" r="7.5" fill="none" />
                <circle className={styles.iconCircle} cx="8" cy="8" r="4" />
              </svg>
              {label}
            </label>
          </li>
        ))}
      </ul>
      {error && (
        <p id={`${referenceId}_error`} className={styles.error}>
          {error}
        </p>
      )}
    </fieldset>
  );
};

export default FormInputRadio;

export type FormInputRadioProps = {
  label: string;
  options: Array<
    {
      label: string;
    } & React.InputHTMLAttributes<HTMLInputElement>
  >;
  id?: string;
  error?: string;
  required?: boolean;
  inputRef?: Ref<HTMLInputElement>;
};
